import cx from 'classnames'
import NextLink from 'next/link'

interface PrintConfiguratorProgressIndicatorItemProps {
  title?: string
  url?: string
  isSelected?: boolean
  showLine?: boolean
  onClick?: () => void
  className?: string
}

const PrintConfiguratorProgressIndicatorItem = ({
  title,
  url,
  isSelected,
  showLine,
  onClick,
  className,
}: PrintConfiguratorProgressIndicatorItemProps) => {
  const itemContent = (
    <>
      <div
        className={cx('w-4 h-4 rounded-full border mx-auto', {
          'bg-white border-gray-light': !isSelected,
          'bg-red border-black': isSelected,
        })}
      />
      {!!title && (
        <span className="text-md font-medium text-center whitespace-nowrap">
          {title}
        </span>
      )}
    </>
  )
  const itemClassName = cx('inline-flex flex-col items-center gap-2 z-10', {
    'cursor-pointer': onClick,
  })

  let item = (
    <div onClick={onClick} className={itemClassName}>
      {itemContent}
    </div>
  )

  if (url) {
    item = (
      <NextLink href={url} className={itemClassName}>
        {itemContent}
      </NextLink>
    )
  }

  return (
    <div
      className={cx('relative flex justify-center items-start px-1', className)}
    >
      {showLine && (
        <div
          className={cx('absolute top-2 h-[1px] bg-gray-light z-0')}
          style={{
            left: '-50%',
            right: '50%',
          }}
        />
      )}

      {item}
    </div>
  )
}

export default PrintConfiguratorProgressIndicatorItem
